import { connect } from 'react-redux';

import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { closeAcceptLeadsPassingModal } from '@/store/reducers/global/actions';
import { selectAcceptLeadsPassingModalConfig } from '@/store/reducers/global/selectors';
import { acceptLeadsPassingProgram } from '@/store/reducers/user/actions';
import { AppState } from '@/types';

import { AcceptLeadsPassingModal as Component } from './AcceptLeadsPassingModal';

const mapStateToProps = (state: AppState) => ({
  ...selectAcceptLeadsPassingModalConfig(state),
  acceptingProgram: selectRequestStatus(state, 'user|acceptLeadsPassingProgram'),
});

const mapActionsToProps = {
  closeModal: closeAcceptLeadsPassingModal,
  acceptProgram: acceptLeadsPassingProgram,
};

export const AcceptLeadsPassingModal = connect(mapStateToProps, mapActionsToProps)(Component);
